import React from 'react';
import PropTypes from 'prop-types';
import { Route } from 'react-router-dom';
import RenderContent from 'app/components/layout/RenderContent';
import HeaderThin from 'app/components/layout/HeaderThin';
import ProfileForm from './components/ProfileForm';
import PaymentMethods from './components/PaymentMethods';
import BankForm from './components/BankForm';

interface IProfileLayoutProps {
  actions: any;
  authentication: any;
  user: any;
  address: any;
  bankAccount: any;
  match: any;
}

export default class ProfileLayout extends React.Component<
IProfileLayoutProps,
{}
> {
  static defaultProps: IProfileLayoutProps = {
    actions: undefined,
    authentication: undefined,
    user: undefined,
    address: undefined,
    bankAccount: undefined,
    match: undefined,
  };

  render() {
    return (
      <RenderContent className="my-dashboard-app" match={this.props.match}>
        <div className="row">
          <div className="col col-12">
            <Route
              exact
              path={['/profile', '/profile/info']}
              render={() => (
                <ProfileForm />
                // <ProfileForm
                //   isLoading={
                //     this.props.user.isLoading || this.props.address.isLoading
                //   }
                //   actions={this.props.actions}
                //   user={this.props.user}
                //   address={this.props.address}
                //   currentAddress={this.props.address.currentAddress}
                // />
              )}
            />
            <Route
              exact
              path={['/profile/bank']}
              render={() => (
                <BankForm />
              )}
            />
            <Route
              exact
              path={['/profile/payment-methods']}
              render={() => (
                <PaymentMethods />
              )}
            />
          </div>
        </div>
      </RenderContent>
    );
  }
}
